module.exports = __webpack_public_path__ + "img/img23.5ad24553.svg";